import React from 'react';

export default function Wayfinding() {
  return (
    <div
      style={{
        width: '20px',
        height: '20px',
        background: '#447fee',
        borderRadius: '100%',
        border: '3px solid #fff',
        boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.2)',
        transform: 'translate(-50%, -50%)',
      }}
    />
  );
}
